import Snappy from '../../../libs/snappy/snappy';

Snappy.Component.Textarea = class Textarea extends Snappy.BaseComponent {
	static get tagName() {
		return 'fa-textarea';
	}

	constructor(element) {
		super(element);
	}

	render() {
	}
};



// WEBPACK FOOTER //
// ./components/textarea/scripts/textarea.js